import {PageTitle} from "../../components/CummonComponents/PageTitle/PageTitle";
import {Questions} from "../../components/FAQPageComponents/Questions/Questions";
import {ContactLink} from "../../components/CummonComponents/ContactLink/ContactLink";
import {useFAQ, useImageUrl} from "../../queries";
import {Loading} from "../../components/CommonComponents/Loading/Loading";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";

export const FAQ = () => {
    const {data, isLoading} = useFAQ();
    const headerImageUrl = useImageUrl(data?.header_background);

    return (
        <>
            <Helmet>
                <title>FAQ | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <PageTitle image={headerImageUrl}>
                        {data?.header_title}
                    </PageTitle>
                    <Questions data={data}/>
                    <ContactLink
                        titleText={data?.footer_title}
                        btnText={data?.footer_button?.title}
                        href={data?.footer_button?.href}
                    />
                </>
            )}
        </>
    )
}
